// Firebase SDK v10 (ES modules) — CDN imports
import { initializeApp } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-app.js";
import { getAnalytics, isSupported } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-analytics.js";
import { getFirestore } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-firestore.js";
import { collection, query, doc, setDoc, getDocs, getDoc, runTransaction, orderBy, limit } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-firestore.js";
import { getAuth, signInAnonymously } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-auth.js";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDzaC3UZQ3TJ7CqKb6-UZrZNm4mMbANu8s",
  authDomain: "sconliestore.firebaseapp.com",
  databaseURL: "https://sconliestore.firebaseio.com",
  projectId: "sconliestore",
  storageBucket: "sconliestore.appspot.com",
  messagingSenderId: "980116845108",
  appId: "1:980116845108:web:0fa37aa69a98b628849061",
  measurementId: "G-G936QTJ9TQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// getAnalytics throws if environment unsupported (no window/cookies) — guard it
isSupported().then(ok => { if (ok) getAnalytics(app); });
const db = getFirestore(app);

// PARCHE TEMPORAL: auth real = Shopify customer. Firebase no lo conoce, así que
// firmamos anónimo solo para obtener un token y pasar reglas `request.auth != null`.
// authReady resuelve cuando el sign-in termina — esperar antes de escribir en Firestore.
const auth = getAuth(app);
const authReady = signInAnonymously(auth).catch((err) => {
  console.error("Firebase anonymous auth falló:", err);
});

export { db, auth, authReady, collection, query, doc, setDoc, getDocs, getDoc, runTransaction, orderBy, limit };